import { Pipe, PipeTransform } from '@angular/core';
import { find, map } from 'lodash';
import { Section } from '../dynamic-tables.component';

@Pipe({
    name: 'sectionFieldIds',
    standalone: false
})
export class DynamicTablesSectionFieldIdsPipe implements PipeTransform {
  transform(id: string, sections: Section[]): string[] {
    return map(find(sections, { id })?.table.fields, 'id');
  }
}
